import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Grid, Typography } from '@mui/material';
import { getUserDataFromToken, sendVerificationCode, verifyCode } from '../../api/auth';
import InputConfig from '../../Components/InputConfig';
import GeneralButton from '../../Components/GeneralButton';
import useCommonStyles from '../../commonStyles';
import { toast } from 'react-toastify';
import { useSearchParams } from 'react-router-dom';
import { UserContext } from '../../Contexts/UserContext';

export default function CodeVerificationForm() {
	const navigate = useNavigate();
	const [verificationCode, setVerificationCode] = useState('');
	const commonStyleClasses = useCommonStyles();
	const [searchParams] = useSearchParams();
	const email = searchParams.get('email');
	const forgotPassword = searchParams.get('forgotPassword');
	const { setUser } = useContext(UserContext);
	const shouldGetCookieInResponse = forgotPassword === 'true' ? false : true;

	useEffect(() => {
		//NOTE : If its not redirected from forgot password page (ie. via register page or login page), then we need to send the code to email.
		if (forgotPassword === 'false') {
			handleCodeSendingToEmail();
		}
	}, []);

	const handleCodeVerification = async () => {
		try {
			if (!email) {
				toast.error('Email not found! Something went wrong');
				return;
			}

			//NOTE : inFirstTimeUser is true -> This param assures that cookie is automatically set after code verification.
			await verifyCode({
				email,
				code: verificationCode,
				isFirstTimeUser: shouldGetCookieInResponse
			});

			if (shouldGetCookieInResponse) {
				setUser(getUserDataFromToken());
				navigate('/dashboard', { replace: true });
			} else {
				toast.success('Code Verified Successfully');
				navigate(`/forgot-password/new-password?email=${email}`, { replace: true });
			}
		} catch (error) {
			toast.error('Error Verifying Code');
		}
	};

	const handleCodeSendingToEmail = async () => {
		if (!email) {
			toast.error('Email not found! Please go to /login');
			return;
		}
		try {
			await sendVerificationCode({ email });
			toast.success('Verification Code Sent Successfully to your email');
		} catch (error) {
			toast.error('Error Sending Verification Code');
		}
	};

	return (
		<Grid container>
			<Grid item xs={6}>
				<InputConfig
					inputStyles={{ width: '100%', margin: '1rem 0' }}
					isObjectEditor={false}
					directValue={verificationCode}
					updateDirectValue={(value) => {
						setVerificationCode(value);
					}}
				/>
			</Grid>
			<Grid item xs={6}>
				<GeneralButton
					className={`${commonStyleClasses.mediumMarginAround}`}
					color="primary"
					variant="contained"
					size="small"
					onClick={handleCodeVerification}
				>
					<Typography fontWeight="bold">Verify Code</Typography>
				</GeneralButton>
			</Grid>
			{shouldGetCookieInResponse && (
				<Grid item xs={4}>
					<GeneralButton
						className={`${commonStyleClasses.mediumMarginTopAndBottom}`}
						color="primary"
						variant="contained"
						size="medium"
						onClick={handleCodeSendingToEmail}
					>
						<Typography fontWeight="bold">Re Send Code</Typography>
					</GeneralButton>
				</Grid>
			)}
		</Grid>
	);
}
